export const CONSTANTS = { 
    PORTAL: 'MEMBER',
    SUCCESS : 'SUCCESS',
    FAILURE: 'FAILURE'
 };